"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROICalculatorToolbarButtons = exports.ROICalculatorRegistryWidget = exports.ROIElement = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var ROICalculatorLayout_1 = require("ContentTokens/SharedWidgetComponents/ROICalculator/ROICalculatorLayout");
var ROICalculatorPanel_1 = require("./CalculatorPanel/ROICalculatorPanel");
var ROISlider_1 = __importDefault(require("./ROISlider"));
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var ROICalculatorResultNumber_1 = require("ContentTokens/SharedWidgetComponents/ROICalculator/ROICalculatorResultNumber");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var ROICalculatorUtils_1 = require("ContentTokens/SharedWidgetComponents/ROICalculator/ROICalculatorUtils");
var ROITextArea_1 = require("./ROITextArea");
var lodash_1 = require("lodash");
var ROIFormulaEditor_1 = require("./ROIFormulaEditor/ROIFormulaEditor");
var ROICalculatorResultEvaluator_1 = require("ContentTokens/SharedWidgetComponents/ROICalculator/ROICalculatorResultEvaluator/ROICalculatorResultEvaluator");
var ROIVariableNotFoundError_1 = __importDefault(require("ContentTokens/SharedWidgetComponents/ROICalculator/ROICalculatorResultEvaluator/ROIVariableNotFoundError"));
var FormulaErrorUtils_1 = require("./ROIFormulaEditor/FormulaErrorUtils");
var Upload_1 = require("Common/Upload");
var RainbowLoadingBar_1 = __importDefault(require("Common/AtomicUI/RainbowLoadingBar/RainbowLoadingBar"));
var utils_1 = require("@qwilr/kaleidoscope/utils");
var ROITextInput_1 = require("ContentTokens/SharedWidgetComponents/ROICalculator/ROITextInput");
var ROIStep_1 = require("./ROISteps/ROIStep");
var ROIStepsContext_1 = require("./ROISteps/ROIStepsContext");
var UseHistoryTypes_1 = require("DataStores/User/UseHistory/UseHistoryTypes");
var ROICalculatorPresets_1 = require("./ROICalculatorPresets");
var ROITextArea_2 = require("./ROITextArea/ROITextArea");
var ROITourModal_1 = require("./ROITourModal");
var react_transition_group_1 = require("react-transition-group");
var classnames_1 = __importDefault(require("classnames"));
var utils_2 = require("@qwilr/kaleidoscope/utils");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var inversify_react_1 = require("inversify-react");
var ColorPalette_1 = __importDefault(require("Common/ColorPalette/ColorPalette"));
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var ColorUtils_1 = require("@CommonFrontendBackend/StyleServiceV2/ColorUtils");
var ROIElement;
(function (ROIElement) {
    ROIElement["Slider"] = "slider";
    ROIElement["VariableInput"] = "variable-input";
    ROIElement["Result"] = "result";
})(ROIElement || (exports.ROIElement = ROIElement = {}));
var ROIElementTheme;
(function (ROIElementTheme) {
    ROIElementTheme["Light"] = "light";
    ROIElementTheme["Dark"] = "dark";
})(ROIElementTheme || (ROIElementTheme = {}));
var ROICalculatorWidget = (function (_super) {
    __extends(ROICalculatorWidget, _super);
    function ROICalculatorWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.uncommittedFormula = _this.props.result.formula;
        _this.showResultOptions = false;
        _this.calculatorSidebarVisible = false;
        _this.widgetId = (0, utils_1.randomString)();
        _this.renderResult = function (containerWidth, isNarrowVariant) {
            var _a = _this.props, variableInputs = _a.variableInputs, result = _a.result, roiStepsOrchestrator = _a.roiStepsOrchestrator;
            var prefix = result.prefix, suffix = result.suffix, formula = result.formula;
            var formulaErrorDetail = _this.formulaErrorDetail;
            var formattedResult = "--";
            try {
                var calculatedResult = (0, ROICalculatorResultEvaluator_1.substituteAndCalculateRoiResult)(formula, variableInputs, _this.sliderValue);
                formattedResult = (0, ROICalculatorUtils_1.roundAndFormatRoiResult)(calculatedResult);
            }
            catch (_b) { }
            var maybeWrapWithROIStep = function (children) {
                return isNarrowVariant && _this.calculatorSidebarVisible ? (children) : (react_1.default.createElement(ROIStep_1.ROIStep, { id: UseHistoryTypes_1.ROIStepId.Formula }, children));
            };
            return (react_1.default.createElement("div", { className: (0, classnames_1.default)("roi-calculator-result", _this.theme) },
                react_1.default.createElement("div", { className: "roi-calculator-result__inner user-font" },
                    react_1.default.createElement("div", { className: "roi-calculator-result__inner-wrap", "data-interactive-zone": true },
                        react_1.default.createElement("div", { onMouseDown: _this.handleResultMouseDown, className: "roi-calculator__clickable-result" },
                            react_1.default.createElement(ROICalculatorResultNumber_1.ROICalculatorResultNumber, { containerWidth: containerWidth, value: formattedResult, prefix: prefix, suffix: suffix })),
                        react_1.default.createElement("div", { className: "roi-calculator__option-button--offset" }, maybeWrapWithROIStep(react_1.default.createElement(kaleidoscope_1.Popover, { autoStack: true, onChange: _this.toggleShowResultOptions, isOpen: _this.showResultOptions, position: kaleidoscope_1.PopoverPosition.Bottom, className: "roi-calculator-options", button: function (buttonProps) { return (react_1.default.createElement("div", { className: "roi-calculator-options__button roi-calculator-result__options-button" },
                                react_1.default.createElement(kaleidoscope_1.IconButton, __assign({ icon: react_1.default.createElement(icons_1.Edit, null), "aria-label": "Edit", tooltip: {
                                        content: "ROI options",
                                        show: roiStepsOrchestrator.shouldShowStep(UseHistoryTypes_1.ROIStepId.Formula) ? false : undefined,
                                    } }, buttonProps, { onClick: _this.handleResultEditClick })),
                                formulaErrorDetail && (react_1.default.createElement("div", { className: "roi-calculator-formula-error" },
                                    react_1.default.createElement(kaleidoscope_1.Tooltip, { content: (0, FormulaErrorUtils_1.getFormulaErrorCopy)(formulaErrorDetail), size: kaleidoscope_1.TooltipSize.Large },
                                        react_1.default.createElement(icons_1.Warning, null)))))); } }, _this.renderResultOptions()))))),
                react_1.default.createElement("div", { className: "user-font roi-calculator-result__label" },
                    react_1.default.createElement(ROITextArea_1.ROITextArea, { placeholder: "ROI calculator label", label: "Describe your ROI", onChange: _this.makeRichTextChangeHandler("roiResult.label"), value: (0, ROICalculatorUtils_1.getPlainTextFromRoiRichText)(_this.props.result.label), centered: true, className: "roi-result__textarea", theme: _this.elementTheme === ROIElementTheme.Light ? ROITextArea_2.ROITextAreaTheme.Light : ROITextArea_2.ROITextAreaTheme.Dark, disabled: isNarrowVariant && _this.calculatorSidebarVisible }))));
        };
        _this.renderResultOptions = function () {
            var _a = _this.props.result, prefix = _a.prefix, suffix = _a.suffix;
            return (react_1.default.createElement("div", { className: "roi-calculator-options__inner" },
                react_1.default.createElement("div", { className: "roi-calculator-options__heading" }, "ROI Options"),
                react_1.default.createElement("div", { className: "roi-calculator-options__dual" },
                    react_1.default.createElement(ROITextInput_1.ROITextInput, { label: "Prefix", value: prefix, inputName: "prefix", onChange: _this.handleResultOptionsChange, onValueEdited: function (name, value) { return _this.handleEditOption(ROIElement.Result, name, value); } }),
                    react_1.default.createElement(ROITextInput_1.ROITextInput, { label: "Suffix", value: suffix, inputName: "suffix", onChange: _this.handleResultOptionsChange, onValueEdited: function (name, value) { return _this.handleEditOption(ROIElement.Result, name, value); } })),
                react_1.default.createElement(ROIStep_1.ROIStep, { id: UseHistoryTypes_1.ROIStepId.FormulaEditor },
                    react_1.default.createElement(ROIFormulaEditor_1.ROIFormulaEditor, { formulaErrorDetail: _this.formulaErrorDetail, onChangeFormula: _this.handleChangeFormula, onCommitFormula: _this.handleCommitFormula, formula: _this.uncommittedFormula, sliderLabel: _this.props.slider.label, variableInputs: Object.entries(_this.props.variableInputs) }))));
        };
        _this.renderLoadingPlaceholder = function () {
            if (_this.uploadProgress && _this.uploadProgress.percent) {
                return react_1.default.createElement(RainbowLoadingBar_1.default, { percent: _this.uploadProgress.percent });
            }
        };
        _this.trackSliderInteraction = function () {
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("roiCalculator", { action: "trackSliderInteraction" }));
        };
        _this.trackVariableInputInteraction = function (key) {
            var inputs = Object.keys(_this.props.variableInputs);
            var eventData = {
                action: "trackVariableInteraction",
                count: inputs.length,
                position: (0, lodash_1.findIndex)(inputs, function (x) { return x === key; }),
            };
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("roiCalculator", eventData));
        };
        _this.handleVariableInputChange = function (id, key, value) {
            var _a, _b;
            var current = _this.props.variableInputs[id];
            var input = (_a = {},
                _a[id] = __assign(__assign({}, current), (_b = {}, _b[key] = value, _b)),
                _a);
            var updateData = {
                action: "updateVariableInputs",
                path: _this.props.widgetManager.getPath(_this.props.element),
                toUpdate: input,
            };
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("roiCalculator", updateData));
        };
        _this.handleEditOption = function (element, optionName, optionValue) {
            var updateData = {
                action: "editOption",
                path: _this.props.widgetManager.getPath(_this.props.element),
                element: element,
                key: optionName,
                value: optionValue,
            };
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("roiCalculator", updateData));
        };
        _this.handleSliderOptionsChange = function (key, value) {
            var _a;
            var current = _this.props.slider;
            var slider = __assign(__assign({}, current), (_a = {}, _a[key] = value, _a));
            var updateData = {
                action: "updateOptions",
                path: _this.props.widgetManager.getPath(_this.props.element),
                toUpdate: { slider: slider },
            };
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("roiCalculator", updateData));
        };
        _this.handleResultOptionsChange = function (optionName, optionValue) {
            var _a;
            var current = _this.props.result;
            var roiResult = __assign(__assign({}, current), (_a = {}, _a[optionName] = optionValue, _a));
            var updateData = {
                action: "updateOptions",
                path: _this.props.widgetManager.getPath(_this.props.element),
                toUpdate: { roiResult: roiResult },
            };
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("roiCalculator", updateData));
        };
        _this.makeRichTextChangeHandler = function (richTextKey) { return function (newValue) {
            var updateData = {
                action: "updateRichText",
                path: _this.props.widgetManager.getPath(_this.props.element),
                richTextKey: richTextKey,
                value: newValue,
            };
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("roiCalculator", updateData));
        }; };
        _this.handleRemoveVariableInput = function (variableKey) {
            var count = Object.keys(_this.props.variableInputs).length;
            var variables = (0, lodash_1.cloneDeep)(_this.props.variableInputs);
            delete variables[variableKey];
            var updateData = {
                action: "removeVariableInput",
                path: _this.props.widgetManager.getPath(_this.props.element),
                toUpdate: { inputs: variables },
                count: count - 1,
            };
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("roiCalculator", updateData));
        };
        _this.handleAddVariableInput = function () {
            var count = Object.keys(_this.props.variableInputs).length;
            _this.props.roiStepsOrchestrator.completeStep(UseHistoryTypes_1.ROIStepId.AddEditVariables);
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("roiCalculator", {
                action: "addVariableInput",
                path: _this.props.widgetManager.getPath(_this.props.element),
                count: count + 1,
            }));
        };
        _this.handleCommitFormula = function () {
            _this.handleResultOptionsChange("formula", _this.uncommittedFormula);
            _this.handleEditOption(ROIElement.Result, "formula", _this.uncommittedFormula);
        };
        _this.handleChangeFormula = function (formula) {
            _this.uncommittedFormula = formula;
        };
        _this.trackUpload = function () {
            if (_this.uploadProgress) {
                switch (_this.uploadProgress.state) {
                    case Upload_1.UploadState.Success: {
                        _this.handleBackgroundImageUploadSuccess(_this.uploadProgress.url);
                        break;
                    }
                    case Upload_1.UploadState.Pending: {
                        (0, mobx_1.autorun)(function (reaction) {
                            _this.trackedUploadReaction = reaction;
                            if (_this.uploadProgress && _this.uploadProgress.url) {
                                _this.handleBackgroundImageUploadSuccess(_this.uploadProgress.url);
                                _this.trackedUploadReaction.dispose();
                            }
                        });
                        break;
                    }
                    case Upload_1.UploadState.Error: {
                        if (_this.trackedUploadReaction) {
                            _this.trackedUploadReaction.dispose();
                        }
                        var errorMessage = _this.renderImageUploadErrorMessage();
                        _this.notifyUser.error(errorMessage);
                    }
                }
            }
        };
        _this.handleBackgroundImageUploadSuccess = function (url) {
            if (!!url) {
                var ev = new WidgetManager_1.WidgetEvent("roiCalculator", {
                    action: "uploadImage",
                    path: _this.props.widgetManager.getPath(_this.props.element),
                    url: url,
                });
                _this.props.widgetManager.triggerEvent(ev);
            }
        };
        _this.handleClickBackgroundImageButton = function (event) {
            event.preventDefault();
            var ev = new WidgetManager_1.WidgetEvent("roiCalculator", {
                action: _this.props.backgroundImageUrl ? "removeImage" : "pickImage",
                path: _this.props.widgetManager.getPath(_this.props.element),
            });
            _this.props.widgetManager.triggerEvent(ev);
        };
        _this.renderImageUploadErrorMessage = function () {
            var _a = _this.props, uploadStore = _a.uploadStore, backgroundImageUploadId = _a.backgroundImageUploadId;
            var retry = function () {
                uploadStore.retry(backgroundImageUploadId);
                _this.trackUpload();
            };
            return react_1.default.createElement(react_1.default.Fragment, null,
                "Image upload failed ",
                react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () { return retry(); } }, "Retry"));
        };
        _this.handleResultMouseDown = function (event) {
            if (!_this.showResultOptions) {
                _this.toggleShowResultOptions();
            }
            _this.props.roiStepsOrchestrator.completeStep(UseHistoryTypes_1.ROIStepId.Formula);
            event.preventDefault();
        };
        _this.handleResultEditClick = function (e) {
            _this.toggleShowResultOptions();
            _this.props.roiStepsOrchestrator.completeStep(UseHistoryTypes_1.ROIStepId.Formula);
        };
        _this.toggleShowResultOptions = function (next) {
            if (next === void 0) { next = !_this.showResultOptions; }
            _this.showResultOptions = next;
            if (!next) {
                _this.props.roiStepsOrchestrator.completeStep(UseHistoryTypes_1.ROIStepId.FormulaEditor);
            }
        };
        _this.handleSelectPreset = function (id) {
            var updateData = {
                action: "selectPreset",
                path: _this.props.widgetManager.getPath(_this.props.element),
                id: id,
            };
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("roiCalculator", updateData));
        };
        var slider = props.slider, notifyUser = props.notifyUser;
        _this.sliderValue = slider.initialValue;
        _this.notifyUser = notifyUser;
        return _this;
    }
    ROICalculatorWidget.prototype.componentDidMount = function () {
        var _this = this;
        var roiStepsOrchestrator = this.props.roiStepsOrchestrator;
        this.disposeStepsAutorunner = (0, mobx_1.autorun)(function () {
            if (roiStepsOrchestrator.shouldShowStep(UseHistoryTypes_1.ROIStepId.ShowVariables) && _this.calculatorSidebarVisible) {
                roiStepsOrchestrator.completeStep(UseHistoryTypes_1.ROIStepId.ShowVariables);
            }
        });
    };
    ROICalculatorWidget.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (prevProps.result.formula !== this.props.result.formula) {
            (0, mobx_1.runInAction)(function () {
                _this.uncommittedFormula = _this.props.result.formula;
            });
        }
        if (prevProps.slider.initialValue !== this.props.slider.initialValue) {
            (0, mobx_1.runInAction)(function () {
                _this.sliderValue = _this.props.slider.initialValue;
            });
        }
        if (prevProps.backgroundImageUploadId !== this.props.backgroundImageUploadId) {
            if (this.trackedUploadReaction) {
                this.trackedUploadReaction.dispose();
            }
            this.trackUpload();
        }
    };
    ROICalculatorWidget.prototype.componentWillUnmount = function () {
        if (this.trackedUploadReaction) {
            this.trackedUploadReaction.dispose();
        }
        this.disposeStepsAutorunner();
    };
    ROICalculatorWidget.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, slider = _a.slider, title = _a.title, description = _a.description, variableCounter = _a.variableCounter, backgroundImageUrl = _a.backgroundImageUrl, roiStepsOrchestrator = _a.roiStepsOrchestrator, widgetManager = _a.widgetManager;
        var backgroundImageButtonText = this.hasBackgroundImage ? "Remove background image" : "Background image";
        return (react_1.default.createElement("div", { className: "project-block__block-element roi-calculator-widget-container" },
            react_1.default.createElement("div", { className: "roi-calculator-widget", contentEditable: false },
                react_1.default.createElement(ROIStepsContext_1.ROIStepsContext.Provider, { value: { orchestrator: roiStepsOrchestrator } },
                    this.props.hasSelectedPreset && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: "roi-calculator__background-image-button", "data-interactive-zone": true },
                            react_1.default.createElement(kaleidoscope_1.IconButton, { icon: this.hasBackgroundImage ? react_1.default.createElement(icons_1.RemoveImage, null) : react_1.default.createElement(icons_1.Image, null), tooltip: { content: backgroundImageButtonText }, type: kaleidoscope_1.ButtonType.Secondary, "aria-label": backgroundImageButtonText, onClick: this.handleClickBackgroundImageButton })),
                        react_1.default.createElement(ROICalculatorLayout_1.ROICalculatorLayout, { widgetId: this.widgetId, backgroundImageUrl: backgroundImageUrl, backgroundImagePlaceholder: this.isUploadingBackgroundImage ? this.renderLoadingPlaceholder() : undefined, sidebarVisible: this.calculatorSidebarVisible, onToggleSidebarVisible: (0, mobx_1.action)(function () {
                                _this.calculatorSidebarVisible = !_this.calculatorSidebarVisible;
                                if (!_this.calculatorSidebarVisible) {
                                    roiStepsOrchestrator.completeStep(UseHistoryTypes_1.ROIStepId.AddEditVariables);
                                }
                            }), calculator: react_1.default.createElement(ROICalculatorPanel_1.ROICalculatorPanel, { widgetId: this.widgetId, inputs: this.props.variableInputs, onVariableInputChange: this.handleVariableInputChange, title: (0, ROICalculatorUtils_1.getPlainTextFromRoiRichText)(title), onTitleChange: this.makeRichTextChangeHandler("title"), description: (0, ROICalculatorUtils_1.getPlainTextFromRoiRichText)(description), onDescriptionChange: this.makeRichTextChangeHandler("description"), onRemoveVariableInput: this.handleRemoveVariableInput, onAddVariableInput: this.handleAddVariableInput, variableCounter: variableCounter, onEditOption: this.handleEditOption, roiStepsOrchestrator: roiStepsOrchestrator, trackVariableInputValueChange: this.trackVariableInputInteraction }), result: function (_a) {
                                var containerWidth = _a.containerWidth, isNarrowVariant = _a.isNarrowVariant;
                                return _this.renderResult(containerWidth, isNarrowVariant);
                            }, slider: function (_a) {
                                var isNarrowVariant = _a.isNarrowVariant;
                                return (react_1.default.createElement(ROISlider_1.default, { label: slider.label, value: _this.sliderValue, max: slider.max, min: slider.min, increment: slider.increment, initialValue: slider.initialValue, onChangeValue: function (value) {
                                        return (0, mobx_1.runInAction)(function () {
                                            _this.sliderValue = value;
                                        });
                                    }, onChangeOption: _this.handleSliderOptionsChange, onEditOption: _this.handleEditOption, brandStore: _this.props.brandStore, blockStore: _this.props.blockStore, theme: _this.theme, roiStepsOrchestrator: roiStepsOrchestrator, trackSliderInteraction: _this.trackSliderInteraction, suppressEditSliderStep: isNarrowVariant && _this.calculatorSidebarVisible }));
                            }, wrapToggleSidebarButton: function (_a) {
                                var children = _a.children;
                                return react_1.default.createElement(ROIStep_1.ROIStep, { id: UseHistoryTypes_1.ROIStepId.ShowVariables }, children);
                            } }),
                        roiStepsOrchestrator.shouldShowStep(UseHistoryTypes_1.ROIStepId.StartTour) && (react_1.default.createElement(ROITourModal_1.ROITourModal, { onCancel: function () {
                                roiStepsOrchestrator.completeAllSteps();
                                widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("roiCalculator", { action: "tourModalClosed", tourStarted: false }));
                            }, onConfirm: function () {
                                roiStepsOrchestrator.completeStep(UseHistoryTypes_1.ROIStepId.StartTour);
                                widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("roiCalculator", { action: "tourModalClosed", tourStarted: true }));
                            } })))),
                    react_1.default.createElement(react_transition_group_1.Transition, { onExit: utils_2.forceReflow, in: !this.props.hasSelectedPreset, timeout: kaleidoscope_2.AnimationDuration.Medium, mountOnEnter: true, unmountOnExit: true }, function (status) { return (react_1.default.createElement("div", { className: (0, classnames_1.default)("roi-presets-wrapper", "roi-presets-wrapper--".concat(status)) },
                        react_1.default.createElement(ROICalculatorPresets_1.ROICalculatorPresets, { onSelection: _this.handleSelectPreset, title: "Choose a preset" }))); }))),
            children));
    };
    Object.defineProperty(ROICalculatorWidget.prototype, "hasBackgroundImage", {
        get: function () {
            return !!this.props.backgroundImageUrl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ROICalculatorWidget.prototype, "theme", {
        get: function () {
            return this.elementTheme === ROIElementTheme.Light ? tokens_1.lightTheme : tokens_1.darkTheme;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ROICalculatorWidget.prototype, "elementTheme", {
        get: function () {
            if (this.hasBackgroundImage) {
                return ROIElementTheme.Dark;
            }
            var blockTextColor = this.props.blockStore.blockStyleStore.getElementStyle("roiCalculator").textColor;
            return blockTextColor === "dark" ? ROIElementTheme.Light : ROIElementTheme.Dark;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ROICalculatorWidget.prototype, "uploadProgress", {
        get: function () {
            var _a = this.props, uploadStore = _a.uploadStore, backgroundImageUploadId = _a.backgroundImageUploadId;
            if (backgroundImageUploadId) {
                return uploadStore.getUploadProgress(backgroundImageUploadId);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ROICalculatorWidget.prototype, "isUploadingBackgroundImage", {
        get: function () {
            return this.uploadProgress && this.uploadProgress.state === Upload_1.UploadState.Pending;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ROICalculatorWidget.prototype, "formulaErrorDetail", {
        get: function () {
            try {
                (0, ROICalculatorResultEvaluator_1.substituteAndCalculateRoiResult)(this.props.result.formula, this.props.variableInputs, this.sliderValue);
            }
            catch (error) {
                if (error instanceof ROIVariableNotFoundError_1.default) {
                    return { type: FormulaErrorUtils_1.FormulaErrorType.VariableNotFound, variable: error.variableName };
                }
                return { type: FormulaErrorUtils_1.FormulaErrorType.FormulaNotEvaluatable };
            }
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], ROICalculatorWidget.prototype, "sliderValue", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ROICalculatorWidget.prototype, "uncommittedFormula", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof mobx_1.IReactionPublic !== "undefined" && mobx_1.IReactionPublic) === "function" ? _a : Object)
    ], ROICalculatorWidget.prototype, "trackedUploadReaction", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ROICalculatorWidget.prototype, "showResultOptions", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ROICalculatorWidget.prototype, "calculatorSidebarVisible", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ROICalculatorWidget.prototype, "componentDidMount", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ROICalculatorWidget.prototype, "hasBackgroundImage", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ROICalculatorWidget.prototype, "theme", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROICalculatorWidget.prototype, "trackSliderInteraction", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROICalculatorWidget.prototype, "trackVariableInputInteraction", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROICalculatorWidget.prototype, "handleVariableInputChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROICalculatorWidget.prototype, "handleEditOption", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROICalculatorWidget.prototype, "handleSliderOptionsChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROICalculatorWidget.prototype, "handleResultOptionsChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROICalculatorWidget.prototype, "makeRichTextChangeHandler", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROICalculatorWidget.prototype, "handleRemoveVariableInput", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROICalculatorWidget.prototype, "handleAddVariableInput", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROICalculatorWidget.prototype, "handleCommitFormula", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROICalculatorWidget.prototype, "handleChangeFormula", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ROICalculatorWidget.prototype, "uploadProgress", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ROICalculatorWidget.prototype, "isUploadingBackgroundImage", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROICalculatorWidget.prototype, "trackUpload", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROICalculatorWidget.prototype, "handleBackgroundImageUploadSuccess", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ROICalculatorWidget.prototype, "formulaErrorDetail", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROICalculatorWidget.prototype, "toggleShowResultOptions", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROICalculatorWidget.prototype, "handleSelectPreset", void 0);
    ROICalculatorWidget = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ROICalculatorWidget);
    return ROICalculatorWidget;
}(react_1.default.Component));
var ROICalculatorRegistryWidget = function (_a) {
    var element = _a.element, children = _a.children;
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var brandStore = (0, inversify_react_1.useInjection)("brandStore");
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var notifyUser = (0, inversify_react_1.useInjection)("notifyUser");
    var roiStepsOrchestrator = (0, inversify_react_1.useInjection)("roiStepsOrchestrator");
    var uploadStore = (0, inversify_react_1.useInjection)("uploadStore");
    var _b = element.data, slider = _b.slider, variableInputs = _b.inputs, variableCounter = _b.variableCounter, backgroundImageUrl = _b.backgroundImageUrl, backgroundImageUploadId = _b.backgroundImageUploadId, description = _b.description, title = _b.title, hasSelectedPreset = _b.hasSelectedPreset, roiResult = _b.roiResult;
    return (react_1.default.createElement(ROICalculatorWidget, { slider: slider, variableInputs: variableInputs, variableCounter: variableCounter, backgroundImageUrl: backgroundImageUrl, backgroundImageUploadId: backgroundImageUploadId, blockStore: blockStore, brandStore: brandStore, description: description, hasSelectedPreset: hasSelectedPreset, notifyUser: notifyUser, result: roiResult, title: title, roiStepsOrchestrator: roiStepsOrchestrator, uploadStore: uploadStore, widgetManager: widgetManager, element: element }, children));
};
exports.ROICalculatorRegistryWidget = ROICalculatorRegistryWidget;
exports.ROICalculatorToolbarButtons = (0, mobx_react_1.observer)(function (_a) {
    var element = _a.element;
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var brandStore = (0, inversify_react_1.useInjection)("brandStore");
    var roiStepsOrchestrator = (0, inversify_react_1.useInjection)("roiStepsOrchestrator");
    if (!element.data.hasSelectedPreset || roiStepsOrchestrator.shouldShowStep(UseHistoryTypes_1.ROIStepId.StartTour)) {
        return undefined;
    }
    var styles = blockStore.blockStyleStore.getElementStyle("roiCalculator");
    var setStyles = function (nextStyles) {
        blockStore.blockStyleStore.setElementStyle("roiCalculator", nextStyles);
    };
    var handleChangeTintColor = function (color) {
        var nextStyles = (0, lodash_1.cloneDeep)(styles);
        nextStyles.tint.color = color;
        setStyles(nextStyles);
    };
    var hasBackgroundImage = !!element.data.backgroundImageUrl;
    var renderColorPalette = function (label, selectedColor, onChange) {
        return (react_1.default.createElement("div", { className: "style-shortcut__section" },
            react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s" },
                react_1.default.createElement(kaleidoscope_1.Label, { size: "s", theme: "dark" }, label),
                react_1.default.createElement("div", { className: "style-shortcut__buttons-container" },
                    react_1.default.createElement(ColorPalette_1.default, { presetColors: brandStore.colorsWithThemeIndex, onColorChange: onChange, selectedColor: (0, GetBlockStyle_1.sanitizeColor)(selectedColor, brandStore.colorsWithThemeIndex), type: "content" })))));
    };
    var handleChangeOpacity = function (value) {
        var nextStyles = (0, lodash_1.cloneDeep)(styles);
        nextStyles.tint.opacity = value;
        setStyles(nextStyles);
    };
    var handleChangeImageBlur = function (value) {
        var nextStyles = (0, lodash_1.cloneDeep)(styles);
        nextStyles.background.imageBlur = value;
        setStyles(nextStyles);
    };
    var handleChangeBackgroundColor = function (color) {
        var nextStyles = (0, lodash_1.cloneDeep)(styles);
        nextStyles.background.color = color;
        nextStyles.textColor = (0, ColorUtils_1.shouldUseDarkText)(color.value) ? "dark" : "light";
        setStyles(nextStyles);
    };
    var stylePanelTintSettings = (react_1.default.createElement(react_1.default.Fragment, null,
        renderColorPalette("Tint color", styles.tint.color, handleChangeTintColor),
        react_1.default.createElement(kaleidoscope_1.SliderInput, { label: "Tint opacity", handleValueChange: handleChangeOpacity, theme: kaleidoscope_1.SliderTheme.Dark, initialInputValue: styles.tint.opacity, maximum: 100 }),
        react_1.default.createElement(kaleidoscope_1.SliderInput, { label: "Background image blur", handleValueChange: handleChangeImageBlur, theme: kaleidoscope_1.SliderTheme.Dark, initialInputValue: styles.background.imageBlur, maximum: 30 })));
    var styleBackgroundColourSettings = (react_1.default.createElement(react_1.default.Fragment, null, renderColorPalette("Background color", styles.background.color, handleChangeBackgroundColor)));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(kaleidoscope_1.ToolbarPopover, { autoStack: true, size: kaleidoscope_1.PopoverSize.Small, button: function (buttonProps) { return react_1.default.createElement(kaleidoscope_1.ToolbarButton, __assign({ icon: react_1.default.createElement(icons_1.Styles, null) }, buttonProps)); } }, hasBackgroundImage ? stylePanelTintSettings : styleBackgroundColourSettings)));
});
